module.exports = __webpack_public_path__ + "static/media/agroemisjabaner.66e6a4f1.jpg";